<script>
  export let tabData
  export let isActive

  const id = `panel-${tabData.id}`
</script>

<div
  {id}
  role="tabpanel"
  hidden={!isActive}
  aria-labelledby={`tab-${tabData.id}`}
>
  <slot />
</div>
